import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Prismic from 'prismic-javascript';
import MetaTags from 'react-meta-tags';
import { RichText } from 'prismic-reactjs';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import Bar from './bar';
import Block from './block';
import BlockImage from './block-image';

import LanguageContext from '../../context/LangContext';

class Certificates extends Component {
  state = {
    content: {},
    language: '',
    section: '',
    tipo: '',
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({tipo: this.props.match.params.tipo, section: this.props.match.params.section, language: language});
    this.getContent();
    this.getScroll();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      this.props.match.params.tipo !== this.state.tipo ||
      this.props.match.params.section !== this.state.section ||
      this.state.language !== language
    ) {
      window.scrollTo(0, 0)
      this.setState({tipo: this.props.match.params.tipo, section: this.props.match.params.section, language: language});
      this.getContent();
      this.getScroll();
    }
  }

  getContent = () => {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchContent = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.certificacoes.tipo', this.props.match.params.tipo),
        {lang: language}
      )
      if (response.results[0]) {
        this.setState({content: response.results[0].data});
      }
    }
    fetchContent();
  }

  getScroll = () => {
    if (this.state.section !== '' && document.querySelector(`#${this.props.match.params.section}`)) {
      window.scrollTo(0, document.querySelector(`#${this.props.match.params.section}`).offsetTop - 148)
    }
  }

  slugify = (string) => {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')  
  
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let certificados = ''
    let especificacoes = ''
    let download = ''
    switch (language) {
      case 'pt-br':
        home = 'Início'
        certificados = 'Certificados'
        especificacoes = 'Especificações técnicas'
        download = 'Faça download das especificações técnicas'
        break;
      case 'en-us':
        home = 'Home'
        certificados = 'Certificates'
        especificacoes = 'Technical specifications'
        download = 'Download technical specifications'
        break;
      case 'es-es':
        home = 'Inicio'
        certificados = 'Certificados'
        especificacoes = 'Especificaciones tecnicas'
        download = 'Descargar especificaciones técnicas'
        break;
      default:
    }
    return (
      <div id="certificados">
        <MetaTags>
          <title>{ this.state.content.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.content.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.content.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ certificados } link="/a-guararapes">
          <div>
            <Link to="/">{ home }</Link>
            <Link to="/certificados">{ certificados }</Link>
          </div>
        </Breadcrumbs>
        <Bar tipo={ this.props.match.params.tipo } items={ this.state.content.certificados } />
        <main id="content">
          {
            this.state.content.certificados && this.state.content.certificados.map((item, index) => {
              let pos = '';
              switch (item.posicao_selo) {
                case "Topo":
                  pos = 'top'
                  break;
                case "Meio":
                  pos = 'middle'
                  break;
                case "Rodapé":
                  pos = 'bottom'
                  break;
                default:
              }
              return (
                <Block key={ index } index={ index } slug={ this.slugify(item.nome[0].text) }>
                  <div className="image">
                    <span className="title">
                      { RichText.render(item.nome) }
                    </span>
                    <img  alt="" src={ item.banner.url } />
                    <span className={ `seal ${pos}` }>
                      <img  alt="" src={ item.selo.url } />
                    </span>
                  </div>
                  <div className="text">
                    <span className="title">
                      { RichText.render(item.nome) }
                    </span>
                    { RichText.render(item.conteudo) }
                    <a href={ item.botao.url } target="_blank" rel="noopener noreferrer">
                      <span className="text">
                        { item.texto_botao }
                      </span>
                      <span className="icon">
                        <i></i>
                      </span>
                    </a>
                  </div>
                </Block>
              )
            })
          }
          <BlockImage>
            <div>
              <h2>{ especificacoes }</h2>
              <img  alt="" src={ this.state.content.imagem_especificacao_certificado && this.state.content.imagem_especificacao_certificado.url } />
              <a href={ this.state.content.imagem_especificacao_certificado && this.state.content.imagem_especificacao_certificado.url } target="_blank" rel="noopener noreferrer">
                <span className="text">
                  { download }
                </span>
                <span className="icon">
                  <i></i>
                </span>
              </a>
            </div>
          </BlockImage>
        </main>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Certificates.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Certificates.contextType = LanguageContext;

export default Certificates;
